import React, {useEffect, useRef, useState} from 'react'
import {Button, Col, Nav, Tab} from 'react-bootstrap'

import {useAuth} from '../../../../context/authContext';
import {useHospitalEventsContext} from "../context/HospitalEvents.context";

import {hospitalEventFilterParams} from '../constants';

const componentName = 'HospitalEventCard';

/**
 * Displays a header for the hospital events section, including filter selection and new patient action button.
 *
 * @param {Object} patient - The patient object.
 */
const HospitalEventsHeader = ({ patient }) => {
  const auth = useAuth();
  const hasWriteAccess = auth.hasAnyAuthority(["AUTH_PD_HOSPITAL_EVENTS_WRITE_ACCESS"]);

  const {
    getHospitalEvents,
    toggleNewHospitalEventModalActive
  } = useHospitalEventsContext();

  const [selectedTab, setSelectedTab] = useState("all");
  const patientId = patient?.id;
  const requestKeyRef = useRef(null);

  const onSelectTab = (tabKey) => {
    setSelectedTab(tabKey);
  }

  useEffect(() => {
    if (!patientId) {
      return;
    }

    const filterParams = [hospitalEventFilterParams[selectedTab] || []].flat();
    const requestKey = `${patientId}:${selectedTab}:${JSON.stringify(filterParams)}`;
    if (requestKeyRef.current === requestKey) {
      return;
    }

    requestKeyRef.current = requestKey;
    getHospitalEvents(patientId, { filters: filterParams });
    // HospitalEventsContext recreates callbacks when request state changes.
    // Filter loading should run only when the selected patient or tab changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId, selectedTab])

  return (
    <Tab.Container defaultActiveKey="all">
      <Nav variant="tabs" as="nav" className="patientdrawer-tabs align-items-center stickyscroll bg-light px-3" onSelect={onSelectTab}>
        <Nav.Link eventKey="all" className="nav-item rounded-start">All</Nav.Link>
        <Nav.Link eventKey="inpatient" className="nav-item rounded-0">Inpatient</Nav.Link>
        <Nav.Link eventKey="behavioral" className="nav-item rounded-0">Behavioral</Nav.Link>
        <Nav.Link eventKey="emergency" className="nav-item rounded-start-0 rounded-end">Emergency</Nav.Link>
        <Col className='text-end'>
          <Button
            id={`${componentName}-new-Hospital-Event`}
            variant="primary"
            disabled={!hasWriteAccess}
            onClick={() => {
              toggleNewHospitalEventModalActive(true)
            }}
          >
            New Hospital Event
          </Button>
        </Col>
      </Nav>
    </Tab.Container>
  );
}

export default HospitalEventsHeader;
